import { error, info, success } from "App/popupMessage";
import { getPayload, getStatus, isPromise, processResponse } from "Common/api/apiMiddleware.utils";
import { COMPLETED_POSTFIX, REJECTED_POSTFIX } from "Common/namespaceUtils/namespaceRedux";
import compact from "lodash/compact";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import isFunction from "lodash/isFunction";
import join from "lodash/join";
import { v4 as uuid } from "uuid";
import { NAMESPACE, defaultTimeout } from "./constants";
import actionTypes from "./redux/actionTypes";
import messageType from "./utils/messageType";
const messageTypeMap = {
    [messageType.ERROR]: error,
    [messageType.INFO]: info,
    [messageType.SUCCESS]: success
};
const notify = (notifyMessage, notifyMessageType, action, store) => {
    const func = messageType && isFunction(notifyMessageType && messageTypeMap[notifyMessageType])
        ? notifyMessageType && messageTypeMap[notifyMessageType]
        : error;
    if (!func || !notifyMessage)
        return;
    const messageLink = !isEmpty(action.messageLink)
        ? notifyMessageType && !isEmpty(action.messageLink[notifyMessageType])
            ? action.messageLink[notifyMessageType]
            : action.messageLink
        : undefined;
    store.dispatch(func(notifyMessage, messageLink));
};
const errorCallback = (payload, store, action, scope, id, timer, resolve) => {
    var _a, _b;
    let notificationMessage = get(payload === null || payload === void 0 ? void 0 : payload.response, "data.data");
    if (!notificationMessage && ((_b = (_a = payload === null || payload === void 0 ? void 0 : payload.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.text)) {
        try {
            payload === null || payload === void 0 ? void 0 : payload.response.data.text().then((bodyResponse) => {
                const obj = JSON.parse(bodyResponse);
                notificationMessage = join(compact([action.rejectedMessage, obj === null || obj === void 0 ? void 0 : obj.data]), ":\r\n");
                notificationMessage && notify(notificationMessage, undefined, action, store);
            });
        }
        catch (_) {
            notificationMessage = "";
        }
    }
    else {
        notificationMessage = join(compact([action.rejectedMessage, notificationMessage]), ":\r\n");
        if (notificationMessage) {
            const responseMessageType = get(payload === null || payload === void 0 ? void 0 : payload.response, "data.messageType");
            notify(notificationMessage, responseMessageType, action, store);
        }
    }
    timer && clearTimeout(timer);
    const pendingRequest = store.getState()[NAMESPACE][scope];
    if (pendingRequest && pendingRequest.id === id) {
        store.dispatch({
            type: `${action.type}${REJECTED_POSTFIX}`,
            payload,
            meta: action.meta
        });
        if (action.rejected && (payload === null || payload === void 0 ? void 0 : payload.code) !== "ECONNABORTED") {
            action.rejected(store.dispatch, { payload, meta: action.meta });
        }
    }
    resolve({ error: get(payload.response, "data.data", "") });
    store.dispatch({ type: actionTypes.REQUEST_REJECTED, id, scope });
};
const createApiMiddleware = ({ actionId = uuid, responseProcessor }) => (store) => {
    const promises = {};
    return (next) => (action) => {
        if (action.payload) {
            const scope = action.scope || action.type;
            let promise = isPromise(action.payload) ? action.payload : null;
            if (!promise && action.payload.promise) {
                if (isPromise(action.payload.promise)) {
                    promise = action.payload.promise;
                }
                else if (isFunction(action.payload.promise)) {
                    const pendingRequest = store.getState()[NAMESPACE][scope];
                    return !pendingRequest
                        ? store.dispatch({ ...action, payload: action.payload.promise() })
                        : promises[scope];
                }
            }
            if (promise) {
                let timer = null;
                const id = actionId();
                store.dispatch({ type: actionTypes.REQUEST_STARTED, id, scope });
                timer = setTimeout(() => {
                    timer && store.dispatch({ type: actionTypes.REQUEST_INPROGRESS, id, scope });
                }, defaultTimeout);
                const p = new Promise(resolve => {
                    promise === null || promise === void 0 ? void 0 : promise.then((response) => {
                        if (getStatus(response) === 500) {
                            errorCallback({ response }, store, action, scope, id, timer, resolve);
                            return;
                        }
                        timer && clearTimeout(timer);
                        const pendingRequest = store.getState()[NAMESPACE][scope];
                        if (pendingRequest && pendingRequest.id === id) {
                            if (responseProcessor) {
                                processResponse(response, responseProcessor);
                            }
                            const payloadData = getPayload(response);
                            store.dispatch({
                                type: `${action.type}${COMPLETED_POSTFIX}`,
                                payload: payloadData,
                                meta: action.meta
                            });
                            if (action.completed) {
                                action.completed(store.dispatch, {
                                    payload: payloadData,
                                    meta: action.meta
                                });
                            }
                            resolve({ response: payloadData });
                        }
                        else {
                            resolve({});
                        }
                        store.dispatch({ type: actionTypes.REQUEST_COMPLETED, id, scope });
                    }).catch(ex => {
                        errorCallback(ex, store, action, scope, id, timer, resolve);
                    });
                });
                promises[scope] = p;
                p.finally(() => {
                    delete promises[scope];
                });
                return p;
            }
        }
        return next(action);
    };
};
export default createApiMiddleware;
